import PromiseWorker from 'promise-worker'

let worker
let promiseWorker
let postMessage = false

try {
  worker = new Worker(
    new URL('./worker.js', import.meta.url),
    { type: 'module' }
  )

  promiseWorker = new PromiseWorker(worker)
  postMessage = message => promiseWorker.postMessage(message)

} catch (err) {
  console.log(err)
}

export default {
  postMessage
}

